// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const BUILD_VERSION = {
    "version": "0.0.0",
    "date": "2025-07-17T19:21:28.586Z",
    "hash": "unknown"
};
/* tslint:enable */
